import { ShieldCheck, MapPin, PoundSterling, Zap } from "lucide-react";

const STATS = [
  { icon: MapPin, label: "UK-built", sub: "North East of England" },
  { icon: ShieldCheck, label: "UK GDPR compliant", sub: "Data handled securely" },
  { icon: PoundSterling, label: "From £0", sub: "Free tier to get started" },
  { icon: Zap, label: "Live in production", sub: "Trade Off in daily use" },
];

export const TrustStrip = () => {
  return (
    <section
      data-testid="trust-strip"
      className="border-y border-slate-100 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16 py-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                data-testid={`trust-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center gap-3"
              >
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-blue/10 text-brand-blue">
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <div className="leading-tight">
                  <p className="font-heading font-700 text-brand-navy">
                    {s.label}
                  </p>
                  <p className="text-sm text-slate-500">{s.sub}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
